export const MealTypeOptions = [
  { value: '0', text: 'Breakfast', key: 0 },
  { value: '1', text: 'Lunch', key: 1 },
  { value: '3', text: 'Other', key: 3 },
  { value: '4', text: 'Supper', key: 4 },
];



// WEBPACK FOOTER //
// ./src/pages/salesanalysis/constants/SalesAnalysisConstants.js